import React, { useContext } from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/index.scss";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import theme from "./muiTheme";
import Layout from "./components/Layout/Layout";

// Pages
//Import i18n.ts
import "./i18n";
import HomePage from "./pages/Home/HomePage";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import BillPage from "./pages/Bills/BillsPage";
import ContactPage from "./pages/MyProfile/ContactPage";
import SuppliesPage from "./pages/Supplies/SuppliesPage";
import SuppliesDetailPage from "./pages/Supplies/SuppliesDetailPage";
import PathnameChangeComponent from "./components/PathnameChangeComponent/PathnameChangeComponent";
import TotalEnergiesContextProvider from "./core/store/context/TotalEnergiesContextProvider";
import TotalEnergiesContext from "./core/store/context/TotalEnergiesContext";
import ManagementsPage from "./pages/Managements/ManagementsPage";
import ManagementsUpdateContactPage from "./pages/Managements/ManagementsUpdateContactPage";
import ManagementsClaimsPage from "./pages/Managements/ManagementsClaimsPage";
import ConsumptionsPage from "./pages/Consumptions/ConsumptionsPage";
import ManagementsUpdateAddressPage from "./pages/Managements/ManagementsUpdateAddressPage";
import ManagementUpdateDomiciliation from "./components/ManagementsUpdate/ManagementUpdateDomiciliation/ManagementUpdateDomiciliation";
import ManagementsUpdatePowersPage from "./pages/Managements/ManagementsUpdatePowersPage";
import ManagementsContractEnd from "./components/ManagementsContractEnd/ManagementsContractEnd";
import ManagementOwnershipChange from "./components/ManagementsOwnershipChange/ManagementsOwnershipChange";
import ManagementsDetailPage from "./pages/Managements/ManagementsDetailPage";
import ManagementsUpdateGasFlowPage from "./pages/Managements/ManagementsUpdateGasFlowPage";
import ServicesPage from "./pages/Services/ServicesPage";
import ServicesPowerOptimizerPage from "./pages/Services/ServicesPowerOptimizerPage";
import ServicesCoveragesPage from "./pages/Services/ServicesCoveragesPage";
import ServicesGasFlowOptimizerPage from "./pages/Services/ServicesGasFlowOptimizerPage";
import ServicesInvoiceSimulatorPage from "./pages/Services/ServicesInvoiceSimulator";
import ServicesDetailPage from "./pages/Services/ServicesDetailPage";
import TealiumTrackingWrapper from "./components/TealiumTrackingWrapper/TealiumTrackingWrapper";
import ClientRoutes from "./components/ClientRoutes/ClientRoutes";
import ManagementAgentHOC from "./components/ManagementAgentHOC/ManagementAgentHOC";
import EntitySelectorPage from "./pages/EntitySelector/EntitySelectorPage";
import AgentRoutes from "./components/AgentRoutes/AgentRoutes";
import ManagementsAgentPage from "./pages/Managements/ManagementAgentPage";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

export default function App() {
  return (
    <TotalEnergiesContextProvider>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <TealiumTrackingWrapper />
          <PathnameChangeComponent />
          <AppRoutes />
        </BrowserRouter>
      </ThemeProvider>
    </TotalEnergiesContextProvider>
  );
}

function AppRoutes() {
  const { isAgent } = useContext(TotalEnergiesContext);
  const isAgentValue = isAgent ?? false;

  return (
    <Layout>
      <Routes>
        <Route
          path="*"
          element={<Navigate to={process.env.REACT_APP_HOME!} replace />}
        />
        {/* <Route
                path={process.env.REACT_APP_LOGIN}
                element={<LoginPage />}
              />
              <Route
                path={process.env.REACT_APP_RECOVER_PASSWORD}
                element={<PasswordRecoveryPage />}
              />
              <Route
                path={process.env.REACT_APP_RESET_CREDENTIALS}
                element={<PasswordRecoveryPage />}
              /> */}
        <Route
          path={process.env.REACT_APP_BASE_URL}
          element={
            <Navigate
              to={
                !isAgentValue
                  ? process.env.REACT_APP_HOME!
                  : process.env.REACT_APP_MANAGEMENT!
              }
              replace
            />
            // userData?.token ? (
            //   <Navigate to={process.env.REACT_APP_HOME!} replace />
            // ) : (
            //   <LoginGygiaPage />
            // )
          }
        />
        <Route element={<ProtectedRoute />}>
          {/* Client only routes */}
          <Route element={<ClientRoutes isAgent={isAgentValue} />}>
            {/* Home */}
            <Route path={process.env.REACT_APP_HOME} element={<HomePage />} />

            {/* Bills */}
            <Route path={process.env.REACT_APP_BILLS} element={<BillPage />}>
              <Route path={":idCups"} element={<BillPage />} />
            </Route>

            {/* Supplies */}
            <Route
              path={process.env.REACT_APP_SUPPLIES}
              element={<SuppliesPage />}
            />
            <Route
              path={`${process.env.REACT_APP_SUPPLIES}/:idCups`}
              element={<SuppliesDetailPage />}
            />

            {/* Services */}
            <Route
              path={`${process.env.REACT_APP_SERVICES_DETAIL}/:idIssue`}
              element={<ServicesDetailPage />}
            />
            <Route
              path={process.env.REACT_APP_SERVICES}
              element={<ServicesPage />}
            />
            <Route
              path={process.env.REACT_APP_SERVICES_POWER_OPTIMIZER}
              element={<ServicesPowerOptimizerPage />}
            />
            <Route
              path={process.env.REACT_APP_SERVICES_GASFLOW_OPTIMIZER}
              element={<ServicesGasFlowOptimizerPage />}
            />
            <Route
              path={process.env.REACT_APP_SERVICES_COVERAGES}
              element={<ServicesCoveragesPage />}
            />
            {/* <Route
                  path={process.env.REACT_APP_SERVICES_MARKET_REPORTS}
                  element={<ServicesMarketReportsPage />}
                /> */}
            <Route
              path={process.env.REACT_APP_SERVICES_INVOICE_SIMULATOR}
              element={<ServicesInvoiceSimulatorPage />}
            />
          </Route>

          <Route
            path={process.env.REACT_APP_ENTITY_SELECTOR_PAGE}
            element={
              isAgentValue ? (
                <EntitySelectorPage />
              ) : (
                <Navigate to={process.env.REACT_APP_HOME!} replace />
              )
            }
          />

          {/* <Route
            path={process.env.REACT_APP_PROFILE}
            element={<MyPersonalDataPage />}
          /> */}
          {/* <Route
                  path={process.env.REACT_APP_CHANGE_PASSWORD}
                  element={<MyPasswordPage />}
                />
                <Route
                  path={process.env.REACT_APP_CHANGE_PASSWORD_SUCCESS}
                  element={<MyPasswordSuccessPage />}
                /> */}

          <Route
            path={process.env.REACT_APP_CONTACT}
            element={<ContactPage />}
          />
          <Route
            path={process.env.REACT_APP_MANAGEMENT}
            element={
              !isAgentValue ? (
                <ManagementsPage />
              ) : (
                <ManagementAgentHOC>
                  <ManagementsPage />
                </ManagementAgentHOC>
              )
            }
          />
          <Route
            path={process.env.REACT_APP_MANAGEMENT_UPDATE_CONTACT}
            element={<ManagementsUpdateContactPage />}
          />
          <Route
            path={
              process.env.REACT_APP_MANAGEMENT_UPDATE_CORRESPONDENCE_ADDRESS
            }
            element={<ManagementsUpdateAddressPage />}
          />
          <Route
            path={process.env.REACT_APP_MANAGEMENT_UPDATE_BANK_DOMICILIATION}
            element={<ManagementUpdateDomiciliation />}
          />
          <Route
            path={process.env.REACT_APP_CONSUMPTION}
            element={<ConsumptionsPage />}
          />
          <Route
            path={process.env.REACT_APP_MANAGEMENT_UPDATE_POWERS}
            element={<ManagementsUpdatePowersPage />}
          />
          <Route
            path={process.env.REACT_APP_MANAGEMENT_UPDATE_GAS_FLOW}
            element={<ManagementsUpdateGasFlowPage />}
          />
          <Route
            path={process.env.REACT_APP_MANAGEMENT_CLAIMS}
            element={<ManagementsClaimsPage />}
          />
          <Route
            path={process.env.REACT_APP_MANAGEMENT_CONTRACT_END}
            element={<ManagementsContractEnd />}
          />
          <Route
            path={process.env.REACT_APP_MANAGEMENT_OWNERSHIP_CHANGE}
            element={<ManagementOwnershipChange />}
          />
          <Route
            path={`${process.env.REACT_APP_MANAGEMENT_DETAIL}/:idIssue`}
            element={<ManagementsDetailPage />}
          />
          {/* Agent only routes */}
          <Route element={<AgentRoutes isAgent={isAgentValue} />}>
            <Route
              path={process.env.REACT_APP_MANAGEMENT_AGENT_PAGE}
              element={<ManagementsAgentPage />}
            />
          </Route>
        </Route>
      </Routes>
    </Layout>
  );
}

root.render(<App />);
